import { render, staticRenderFns } from "./ContactPropAdded.vue?vue&type=template&id=71a2842a&scoped=true"
import script from "./ContactPropAdded.vue?vue&type=script&lang=js"
export * from "./ContactPropAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2842a",
  null
  
)

export default component.exports